"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "urlParse", {
  enumerable: true,
  get: function () {
    return _urlParse.default;
  }
});
exports.httpClient = exports.toCurl = exports.expandUrl = void 0;

var _axios = _interopRequireDefault(require("axios"));

var _uritemplate = _interopRequireDefault(require("uritemplate"));

var _urlParse = _interopRequireDefault(require("url-parse"));

var _r2curl = _interopRequireDefault(require("r2curl"));

var _urlJoin = _interopRequireDefault(require("url-join"));

var _querystringify = _interopRequireDefault(require("querystringify"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const expandUrl = (uri, obj) => {
  const tpl = _uritemplate.default.parse(uri);

  return tpl.expand(obj);
};

exports.expandUrl = expandUrl;

const httpClient = ({
  environment,
  method,
  pathTemplate,
  headers,
  parameters,
  body,
  httpConfig
}) => {
  const client = _axios.default.create({
    baseURL: environment.url
  });

  const options = { ...(httpConfig || {}),
    method: method,
    headers: headers
  };
  const expandedUrl = expandUrl(pathTemplate, parameters);
  const destUrl = (0, _urlParse.default)(expandedUrl, true);
  options.params = destUrl.query;
  options.url = destUrl.pathname;
  options.data = body;
  return [client, options];
};

exports.httpClient = httpClient;

const toCurl = ({
  environment,
  method,
  body,
  headers,
  parameters,
  pathTemplate
}) => {
  const expandedUrl = expandUrl(pathTemplate, parameters);
  const destUrl = (0, _urlParse.default)(expandedUrl, true);
  const str = (0, _r2curl.default)({
    url: (0, _urlJoin.default)(environment.url, destUrl.pathname) + _querystringify.default.stringify(destUrl.query, true),
    method: method,
    data: safeParse(body),
    headers: headers
  }); // r2curl does not support PATCH yet, https://github.com/uyu423/r2curl/blob/master/src/enum/HTTP_METHOD.ts

  if (method === "PATCH") {
    return str.replace("-X GET", "-X PATCH");
  }

  return str;
};

exports.toCurl = toCurl;

function safeParse(str) {
  try {
    return JSON.parse(str);
  } catch (err) {
    return str;
  }
}